import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@app/_core/services/user.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { Utils } from './Utils';

// Must match the actual APIErrorLog endpoint path — excluded to prevent recursive logging
const ERROR_LOG_ENDPOINT = 'APIErrorLog';
const CALL_ERROR_LOG_API = false;

@Injectable()
export class errorLoggingInterceptor implements HttpInterceptor {
  constructor(
    private userService: UserService,
    private loaderService: LoaderService,
    private router: Router,
    private confirmDialogComponent: ConfirmDialogComponent
  ) { }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An unknown API error occurred.';

        if (error.status === 0) {
          // Network / CORS / client-side error — no response received
          errorMessage = `Network Error: ${error.message}`;
        } else {
          switch (error.status) {
            case 400:
              errorMessage = error.error?.message || 'Bad Request.';
              break;
            case 401:
              errorMessage = 'Unauthorized. Redirecting to login...';
              this.showSessionExpiredDialog();
              break;
            case 403:
              errorMessage = 'Forbidden. You do not have permission.';
              break;
            case 404:
              errorMessage = 'Requested resource not found.';
              break;
            case 500:
              errorMessage = 'Internal Server Error. Please try again later.';
              break;
            default:
              errorMessage = `Error ${error.status}: ${error.message}`;
          }
        }

        //console.error('API Error:', errorMessage, 'Details:', error);
    
        console.error('[API EXCEPTION]', {
          endpoint: Utils.extractPath(req.url),
          statusCode: error.status,
          message: errorMessage,
          //details: error,
        });

        // this.loaderService.display(false);
        // this.loaderService.setOnDemandLoading(false);

        // // Guard against recursive logging if the logging call itself fails
        // const isLoggingRequest = req.url.includes(ERROR_LOG_ENDPOINT);

        // if (this.userService.isLoggedIn() && CALL_ERROR_LOG_API) {
        //   if (!isLoggingRequest) {
        //     const errorPayload = {
        //       message: error.error?.StackTrace
        //         ? `${error.message} | ${error.error.StackTrace}`
        //         : error.message,
        //       apiInfo: {
        //         url: req.urlWithParams,
        //         params: req.params.toString(), // serializable form
        //       },
        //       status: error.status, // useful for backend-side filtering/reporting
        //     };

        //     this.userService.APIErrorLog(errorPayload).subscribe({
        //       next: (res) => console.log('API Error logged to backend:', res),
        //       error: (logError) =>
        //         console.error('Failed to log API error to backend:', logError),
        //     });
        //   }
        // }

        // Rethrow so specific components can still handle it if needed
        return throwError(() => error);
      })
    );
  }

  // Guard against showing multiple overlapping dialogs when several requests 401 in parallel
  private sessionExpiredDialogShown = false;

  // Shows a brief, button-less message and then redirects to login without waiting for user confirmation.
  private showSessionExpiredDialog(): void {
    if (this.sessionExpiredDialogShown) {
      return;
    }
    this.sessionExpiredDialogShown = true;

    const msg = 'An unexpected error has occurred, redirecting to login...';
    this.confirmDialogComponent
      .showAutoDismissMessage('Error', msg, 5000)
      .then(() => {
        this.userService.logout(true); // errorOccurred = true
      })
      .finally(() => {
        this.sessionExpiredDialogShown = false;
      });
  }
}